export const SizeArray = [50, 100, 200, 500, 800]
export const SortRole = Object.freeze({
  ascending: 'ASC',
  descending: 'DESC',
})
export const SortRoleByte = Object.freeze({
  ascending: 1,
  descending: 0,
})
